import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import {host} from '../../function/api'

export const editSectionOne = createAsyncThunk(
    'editSectionOne',
    async(data, thunkApi) => {
        try {
            const response = await axios({
                method: 'POST',
                _method: 'PATCH',
                url: `${host}sectionOne/${data.id}`,
                data: data,
                headers: {
                    'Accept': 'Application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`,
                    'xsrfHeaderName': "X-XSRF-TOKEN",
                    'withCredentials': true,
                }
        })

            return response.data;

        } catch (error) {
            return thunkApi.rejectWithValue(error);
        }
    }
)

export const sectionIndex = createAsyncThunk(
    'section/index',
    async(data, thunkApi) => {
        try {
            let UrlApi = data.countPerPage ? `${host}sectionOne?section=${data.section}&page=${data.pageNumber}&per_page=${data.countPerPage}&search=${data.search}&delay=1` : `${host}sectionOne`
            const response = await axios({
                method: 'GET',
                url: UrlApi,
                headers: {
                    'Accept': 'Application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`,
                    'xsrfHeaderName': "X-XSRF-TOKEN",
                    'withCredentials': true,
                }
        })

            return response.data;

        } catch (error) {
            return thunkApi.rejectWithValue(error);
        }
    }
)
export const ExhibitionSectionIndex = createAsyncThunk(
    'section/index',
    async(data, thunkApi) => {
        try {
            let UrlApi = data.countPerPage ? `${host}sectionOne?section=${data.section}&page=${data.pageNumber}&per_page=${data.countPerPage}&search=${data.search}&delay=1` : `${host}sectionOne`
            const response = await axios({
                method: 'GET',
                url: UrlApi,
                headers: {
                    'Accept': 'Application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`,
                    'xsrfHeaderName': "X-XSRF-TOKEN",
                    'withCredentials': true,
                }
        })

            return response.data;

        } catch (error) {
            return thunkApi.rejectWithValue(error);
        }
    }
)

export const sectionStore = createAsyncThunk(
    'section/store',
    async(data, thunkApi) => {
        try {
            const response = await axios({
                method: 'POST',
                url: `${host}sectionOne`,
                data: data,
                headers: {
                        'Accept': 'Application/json',
                        'xsrfHeaderName': "X-XSRF-TOKEN",
                        'withCredentials': true,
                        'Authorization': `Bearer ${localStorage.getItem('token')}`
                    }        
                })

            return await response.data;

        } catch (error) {
            return thunkApi.rejectWithValue(error);
        }
    }
)


export const ExhibitionSectionStore = createAsyncThunk(
    'section/store',
    async(data, thunkApi) => {
        try {
            const response = await axios({
                method: 'POST',
                url: `${host}sectionOne`,
                data: data,
                headers: {
                        'Accept': 'Application/json',
                        'xsrfHeaderName': "X-XSRF-TOKEN",
                        'withCredentials': true,
                        'Authorization': `Bearer ${localStorage.getItem('token')}`
                    }        
                })

            return await response.data;

        } catch (error) {
            return thunkApi.rejectWithValue(error);
        }
    }
)

const initialState= {
    archiveSectionOneLoading: false,
    archiveSectionOneSuccess: false,
    sections: [],
    CreateMessage: '',
    errorArchives: '',
    errorTitle: '',
    message: '',
    error: '',
}

const sectionOneSlice = createSlice({
    name: 'sectionOne',
    initialState,
    reducers: {

    },
    extraReducers: {
        [editSectionOne.fulfilled]: (state, {payload}) => {  
            state.archiveSectionOneLoading = false
            state.archiveSectionOneSuccess = true
            state.message = payload.message
            state.errorTitle = ""
            state.errorArchive = ""
        },
        [editSectionOne.pending] : (state) => {
            state.archiveSectionOneLoading = true    
            state.archiveSectionOneSuccess = false
        },
        [editSectionOne.rejected]: (state, {payload}) => {
            state.archiveSectionOneLoading = false
            state.archiveSectionOneSuccess = false
            if(payload.response.data.error) {
                state.errorTitle = payload.response.data.error.title
                state.errorArchives = payload.response.data.error.store_id
            }
            if(payload.response.data.message) {
                state.message = payload.response.data.message
            }
            
        },
        [sectionStore.fulfilled]: (state, {payload}) => {  
            state.archiveSectionOneLoading = false
            state.rahpardaznetLoading = false;
            state.archiveSectionOneSuccess = true
            state.CreateMessage = payload.message
            state.message = ""
            state.errorTitle = ""
            state.errorArchive = ""
        },
        [sectionStore.pending] : (state) => {
            state.archiveSectionOneLoading = true  
            state.rahpardaznetLoading = true;  
            state.archiveSectionOneSuccess = false
            state.CreateMessage = ""
            state.message = ""
        },
        [sectionStore.rejected]: (state, {payload}) => {
            state.archiveSectionOneLoading = false
            state.rahpardaznetLoading = false;
            state.archiveSectionOneSuccess = false
            state.CreateMessage = payload.response.data.message
            state.message = ""
            
        },
        [ExhibitionSectionStore.fulfilled]: (state, {payload}) => {  
            state.archiveSectionOneLoading = false
            state.rahpardaznetLoading = false;
            state.archiveSectionOneSuccess = true
            state.CreateMessage = payload.message
            state.message = ""
            state.errorTitle = ""
            state.errorArchive = ""
        },
        [ExhibitionSectionStore.pending] : (state) => {
            state.archiveSectionOneLoading = true  
            state.rahpardaznetLoading = true;  
            state.archiveSectionOneSuccess = false
            state.CreateMessage = ""
            state.message = ""
        },
        [ExhibitionSectionStore.rejected]: (state, {payload}) => {
            state.archiveSectionOneLoading = false
            state.rahpardaznetLoading = false;
            state.archiveSectionOneSuccess = false
            state.CreateMessage = payload.response.data.message
            state.message = ""
            
        },
        [sectionIndex.fulfilled]: (state, action) => {
            state.archiveSectionOneLoading = false
            state.sections = action.payload.data
            state.rahpardaznetLoading = false;
            state.errorTitle = ""
            state.errorArchive = ""
            state.CreateMessage = ""
            state.message = ""
        },
        [sectionIndex.pending]: (state) => {
            state.archiveSectionOneLoading = true
            state.rahpardaznetLoading = true;
            state.CreateMessage = ""
            state.message = ""
        },
        [sectionIndex.rejected]: (state, {payload}) => {
            state.archiveSectionOneLoading = false;
            state.rahpardaznetLoading = false;
            state.archiveSectionOneSuccess = false
            if(payload.response.data.error){
                state.error = payload.response.data.error
            } else if (payload.response.data.message) {
                state.message = payload.response.data.message
            }else{
                state.message = ""
            }
            state.CreateMessage = ""
        },
        [ExhibitionSectionIndex.fulfilled]: (state, action) => {
            state.archiveSectionOneLoading = false
            state.sections = action.payload.data
            state.rahpardaznetLoading = false;
            state.errorTitle = ""
            state.errorArchive = ""
            state.CreateMessage = ""
            state.message = ""
        },
        [ExhibitionSectionIndex.pending]: (state) => {
            state.archiveSectionOneLoading = true
            state.rahpardaznetLoading = true;
            state.CreateMessage = ""
            state.message = ""
        },
        [ExhibitionSectionIndex.rejected]: (state, {payload}) => {
            state.archiveSectionOneLoading = false;
            state.rahpardaznetLoading = false;
            state.archiveSectionOneSuccess = false
            if(payload.response.data.error){
                state.error = payload.response.data.error
            } else if (payload.response.data.message) {
                state.message = payload.response.data.message
            }else{
                state.message = ""
            }
            state.CreateMessage = ""
        }
    }
})

export const {} = sectionOneSlice.actions;
export default sectionOneSlice.reducer; 